@if ((loading$ | async)) {
<div class="spinner-wrapper">
    <div class="spinner"></div>
</div>
}
